import FlyOutBasketIconComponent from './FlyOutBasketIcon';

const FlyOutBasketIcon = {
  VariantComponent: FlyOutBasketIconComponent,
  getSettings: componentSettings => ({
    ...componentSettings
  })
};

export default FlyOutBasketIcon;
